module.exports = __webpack_public_path__ + "static/img/przybornik_menuRysuj_ON.2889c1a9.png";